// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuMobile-module--container--kNlsW","bottomBtn":"MenuMobile-module--bottomBtn--RbjA8","snyrtivara":"MenuMobile-module--snyrtivara--3HlEB"};